// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Insentive_table_wrapper__mz5ST"};